class FootlengthSelect extends HTMLElement {
  constructor() {
    super();

    this.sizes = JSON.parse(document.getElementById(this.dataset.dataId).textContent);
    this.isAdults = this.dataset.isAdults;
    this.isToddlers = this.dataset.isToddlers;
    this.isKids = !this.isAdults && !this.isToddlers ? true : false;

    this.loadSizes();

    // this.querySelector('.js.sizefinder__select__inline-label').addEventListener('click', this.handleOverlay.bind(this));
    this.querySelector('.js.sizefinder__select__inline-label').addEventListener('click', (event) => {
      this.classList.toggle('open');
    });
  }

  reset() {
    this.querySelectorAll('.js.sizefinder__select li').forEach((item) => {
      item.classList.remove('selected');
    });

    const labelPlaceholder = this.querySelector('.js.sizefinder__select__inline-label__placeholder');
    const label = this.querySelector('.js.sizefinder__select__inline-label__current');
    label.innerHTML = labelPlaceholder.innerHTML;
  }

  /**
  * Load sizes from json into select
  */
  loadSizes() {
    const sizeSelect = this.querySelector('.js.sizefinder__select');
    const biggerSizesHint = this.querySelector('.js.hint-bigger-feet');

    // add all sizes in size range
    this.sizes?.sizes?.forEach((size) => {
      let option = document.createElement("li");
      option.innerText = size.length;
      option.dataset.size = size.size;
      option.role = 'option';
      option.addEventListener('click', this.selectFootlength.bind(this));
      if(biggerSizesHint) {
        biggerSizesHint.before(option);
      } else {
        sizeSelect.append(option);
      }
    });

    sizeSelect.addEventListener('change', this.selectFootlength);
  }

  /**
  * Display (and select) recommended size for footlength
  */
  selectFootlength(event) {
    const label = this.querySelector('.js.sizefinder__select__inline-label__current');
    label.innerText = event.currentTarget.innerText;
    event.currentTarget.classList.add('selected');
    this.querySelectorAll('.js.sizefinder__select li').forEach((entry) => {
      if( entry !== event.currentTarget) {
        entry.classList.remove('selected');
      }
    });
    this.classList.toggle('open');
    const variant = document.querySelector(`variant-radios fieldset.js.product-form__input input[value="${event.currentTarget.dataset.size}"]`);
    variant.classList.add('sizefinder-triggered');
    variant.click();

    if (variant.classList.contains('has-notify') && variant.classList.contains('is-soldout')) {
      document.querySelector('.js.sizefinder__results').classList.add('notify');
    } else if (variant.classList.contains('is-soldout')) {
      document.querySelector('.js.sizefinder__results').classList.add('soldout');
    } else {
      document.querySelector('.js.sizefinder__results').classList.remove('notify', 'hidden', 'soldout');
    }

    document.querySelector('.js.sizefinder__results__size span').innerText = event.currentTarget.dataset.size;
    document.querySelector('.js.sizefinder__results').classList.remove('hidden');

    this.datalayerSelectFootlength(event.currentTarget.innerText);
    this.datalayerSuggestion(event.currentTarget.dataset.size);

    // Fire Kameleoon goal conversion
    if (typeof Kameleoon !== 'undefined' && Kameleoon.API && Kameleoon.API.Goals) {
      Kameleoon.API.Goals.processConversion(398608);
    }

    document.querySelector('sizefinder-pdp').dataset.recommendedSize = event.currentTarget.dataset.size;
  }

  datalayerSelectFootlength(footlength = 'no data') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    'event': 'groessenberater_size_selected',
    'length': footlength
    });
  }

  datalayerSuggestion(suggestedSize = 'no data') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    'event': 'groessenberater_suggestion',
    'size': suggestedSize
    });
  }
}

customElements.define('footlength-select', FootlengthSelect);